/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListIdentityProviderConnectionApplicationsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListIdentityProviderConnectionApplicationsRequest = {
  /**
   * Connection ID.
   */
  id: string;
  /**
   * Include applications that disappeared from a run.
   */
  includeRemoved?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListIdentityProviderConnectionApplicationsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListIdentityProviderConnectionApplicationsSecurity$outboundSchema:
  z.ZodMiniType<
    ListIdentityProviderConnectionApplicationsSecurity$Outbound,
    ListIdentityProviderConnectionApplicationsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listIdentityProviderConnectionApplicationsSecurityToJSON(
  listIdentityProviderConnectionApplicationsSecurity:
    ListIdentityProviderConnectionApplicationsSecurity,
): string {
  return JSON.stringify(
    ListIdentityProviderConnectionApplicationsSecurity$outboundSchema.parse(
      listIdentityProviderConnectionApplicationsSecurity,
    ),
  );
}

/** @internal */
export type ListIdentityProviderConnectionApplicationsRequest$Outbound = {
  id: string;
  include_removed: boolean;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListIdentityProviderConnectionApplicationsRequest$outboundSchema:
  z.ZodMiniType<
    ListIdentityProviderConnectionApplicationsRequest$Outbound,
    ListIdentityProviderConnectionApplicationsRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      includeRemoved: z._default(z.boolean(), false),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        includeRemoved: "include_removed",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listIdentityProviderConnectionApplicationsRequestToJSON(
  listIdentityProviderConnectionApplicationsRequest:
    ListIdentityProviderConnectionApplicationsRequest,
): string {
  return JSON.stringify(
    ListIdentityProviderConnectionApplicationsRequest$outboundSchema.parse(
      listIdentityProviderConnectionApplicationsRequest,
    ),
  );
}
